import { Box, Button, Card, CardContent, FormControl, InputAdornment, OutlinedInput, Typography, CardActions, FormControlProps, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as Styles from "pages/development/settings/tabs/expirationPeriods/expirationPeriods.styles";

interface Props {
    handleChangeYears: (event: any, applicationExpiration: EntityExpirationPeriod, button: string|null) => void;
    expirationPeriods: EntityExpirationPeriod[];
 }

const ExpirationPeriodsList = (props: Props) => 
{
    const { t } = useTranslation();
    const theme = useTheme();


    useEffect(() => {
    }, [props.expirationPeriods]);

    // --- Props ---
    // TypographyProps is bugged and doesn't have component property
    const statusTitleProps: any = {
        variant: "h1",
        component: "div",
        sx: Styles.statusTitle(theme)
    }

    const statusFormControlProps: FormControlProps = {
        variant: "outlined",
        sx: Styles.statusFormControl(theme)
    }

    return (
        <Box sx={Styles.expirationPeriodCardWrapper(theme)}>
            {props.expirationPeriods.map((item, i) => 
                <Box key={i} sx={{maxWidth: 250}}>
                    <Card sx={{mb: 1}}>
                        <CardContent sx={{paddingBottom: 0}}>
                            <Typography {...statusTitleProps} >
                                {t(item.status)}
                            </Typography>
                            <FormControl {...statusFormControlProps}>
                                {/* <FormHelperText id="outlined-weight-helper-text">Bewaartermijn</FormHelperText> */}
                                <OutlinedInput 
                                    inputProps={{ min: 0, max: 100 }}
                                    type="number" 
                                    size="small"
                                    id="outlined-bewaartermijn"
                                    value={item.newValueInyears || ''}
                                    onChange={(newValue: any) => {
                                        props.handleChangeYears(newValue, item, null);
                                    }}
                                    endAdornment={<InputAdornment position="end">{t("settings.expirationPeriods.years")}</InputAdornment>}
                                    aria-describedby="outlined-bewaartermijn"
                                    // inputProps={{
                                    // 'aria-label': 'bewaartermijn',
                                    // }}
                                />
                            </FormControl>                
                        </CardContent>
                        <CardActions sx={{justifyContent: 'center'}}>
                            <Button size="small" color="error" variant="outlined" disabled={item.newValueInyears === item.expirationInYears ? true : false} onClick={() => props.handleChangeYears(null, item, 'delete')}>{t("buttons.cancel")}</Button>
                            <Button size="small" color="success" variant="outlined" disabled={item.newValueInyears === item.expirationInYears ? true : false}  onClick={() => props.handleChangeYears(null, item, 'save')}>{t("buttons.save")}</Button>
                        </CardActions>
                    </Card>
                </Box>
            )}
        </Box>
    );
}

export default ExpirationPeriodsList;